export default __webpack_public_path__ + "static/media/johana_baquero.27b3d6f3.jpeg";